import { Board } from '../types'

export const mockBoards: Board[] = [
  {
    id: 'b1',
    name: 'Dream Home',
    coverImage:
      'https://images.unsplash.com/photo-1598928506311-c55ded91a20c?auto=format&fit=crop&w=600&q=80',
    pinCount: 12,
    isPrivate: false,
  },
  {
    id: 'b2',
    name: 'Design Inspo',
    coverImage:
      'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=600&q=80',
    pinCount: 45,
    isPrivate: false,
  },
  {
    id: 'b3',
    name: 'Recipes to Try',
    coverImage:
      'https://images.unsplash.com/photo-1525351484163-7529414395d8?auto=format&fit=crop&w=600&q=80',
    pinCount: 8,
    isPrivate: true,
  },
  {
    id: 'b4',
    name: 'Travel Bucket List',
    coverImage:
      'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?auto=format&fit=crop&w=600&q=80',
    pinCount: 23,
    isPrivate: false,
  },
]
